<template>
    <table
        class="table-format table dt-responsive nowrap"
        style="width:100% !important">
        <thead>
        <tr>
            <th v-if="showClient" scope="col" style="width: 200px; border: none">Client</th>
            <th v-if="showOrder" scope="col">Order</th>
            <th scope="col">Invoice Date</th>
            <th scope="col">Period</th>
            <th scope="col">Rows</th>
            <th scope="col">Discount</th>
            <th scope="col">Total</th>
            <th scope="col" class="text-center">Skipped</th>
            <th scope="col">Edited By</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(invoice, idx) in invoices" :key="idx" style="position: relative">
            <td v-if="showClient">
                {{ organizations[invoice.order.client.org_id].name }}
            </td>
            <td v-if="showOrder">
                <a :href="`/orders/${invoice.order.number}`">{{ invoice.order.number }}</a>
            </td>
            <td>
                {{ invoice.invoice_date | formatDateYmd }}
            </td>
            <td>
                {{ invoice.invoice_period_start | formatDateYmd }} - {{ invoice.invoice_period_end | formatDateYmd }}
            </td>
            <td>
                <invoice-row
                    :article="'Rental Fee'"
                    :amount="invoice.rental_fee"
                    :currency="invoice.order.currency"
                    :description="invoice.rental_fee_comment && invoice.rental_fee_comment !== '' ? invoice.rental_fee_comment : 'Rental Fee'"
                />
                <invoice-row
                    v-if="invoice.ads_package > 0"
                    :article="'Ads Package'"
                    :amount="invoice.ads_package"
                    :currency="invoice.order.currency"
                    :description="invoice.ads_package_comment && invoice.ads_package_comment !== '' ? invoice.ads_package_comment : 'Ads Package'"
                />
            </td>
            <td>
                <span>{{ invoice.discount }}%</span>
            </td>
            <td>
                <span style="display: block">{{ getTotal(invoice, true) }} {{ invoice.order.currency }}</span>
                <span>{{ getTotal(invoice) }} {{ invoice.order.currency }} (inc. VAT)</span>
            </td>
            <td class="text-center">
                <input type="checkbox" v-model="invoice.is_skipped" style="margin-top: 12px;"
                       onclick="return false;"/>
            </td>
            <td>
                <span style="display: block">
                    {{ invoice.approver && invoice.approver.hasOwnProperty('name') ? invoice.approver.name : '' }}
                </span>
                <span v-if="invoice.approved_at" style="white-space: nowrap;">
                    {{ invoice.approved_at | formatDate }}
                </span>
            </td>
            <td>
                <button
                    type="button"
                    @click="editInvoice(invoice)"
                    class="btn btn-primary"
                    style="display: block"
                >
                    Edit
                </button>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script>
import InvoiceRow from "./InvoiceRow";
import moment from "moment/moment";

export default {
    name: "InvoiceDraftsTable",
    components: {InvoiceRow},
    props: ['invoices', 'organizations', 'showClient', 'showOrder'],
    methods: {
        getVAT(order) {
            if (order.currency === 'SEK') {
                return 0.25;
            }
            if (order.currency === 'GBP') {
                return 0.20;
            }
            return NaN;
        },
        getTotal(invoice, skipVat) {
            const vat = skipVat && skipVat === true ? 0 : this.getVAT(invoice.order);
            const discount = invoice.discount / 100;
            const total = (1 + vat) * (invoice.rental_fee * (1 - discount) + invoice.ads_package * 1);
            return Math.round((total + Number.EPSILON) * 100) / 100;
        },
        editInvoice(invoice) {
            this.$emit('edit-invoice', invoice)
        }
    },
    filters: {
        formatDateYmd(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        formatDate(date) {
            return moment(date).format('MMM Do HH:mm');
        }
    },
}
</script>
